
import { createContext,useReducer } from 'react';
import { createRoutesFromChildren } from 'react-router-dom';
import githubReducer from './GithubReducer';


const GithubContext = createContext()


export const GithubProvider = ({ children }) =>{

    const intialState = {

     users: [],
     repos: [],
     user: {},
     loading: false,
         

    }
 
    const [state, dispatch] = useReducer(githubReducer, intialState)

// 1. Demo Using Fetch users we first done GET intial users - testing purposes

    

        //Get a single user previous function is modifying


  
return <GithubContext.Provider value={{

 ...state,
 dispatch,


 

}}>{children}</GithubContext.Provider>



}

export default GithubContext


